import React from "react";
import Logo from "../../../../Assets/Images/GroupXCZ.png";

const UploadStatusView = ({ status }) => {
  return (
    <div className="my-4">
      <div className="card bg-dark">
        <h4 className="text-warning p-4">
          {status === "time_out"
            ? `Time Has Been Expried`
            : `Your Video Upload successfully Done..!`}
        </h4>
        <hr className="HRx" />
        <center className="mt-5 mb-5">
          <img src={Logo} alt="" className="mt-5" />
          <h5 className="text-warning p-4 mb-5">
            {status === "time_out"
              ? `Time Has Been Expried`
              : `Your Video Upload successfully Done..!`}
          </h5>
        </center>
      </div>
    </div>
  );
};

export default UploadStatusView;
